import { jsx as _jsx } from "react/jsx-runtime";
import _classCallCheck from "/home/moongchigo/www/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "/home/moongchigo/www/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/moongchigo/www/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/moongchigo/www/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/moongchigo/www/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/moongchigo/www/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import Link from 'next/link';
import Character from 'components/ui/Character/Character';
import Vh from 'components/ui/Vh/Vh';
import Button from 'components/ui/Button/Button';
import style from './Error.module.css';

var Error = /*#__PURE__*/function (_Component) {
  _inherits(Error, _Component);

  var _super = _createSuper(Error);

  function Error() {
    var _this;

    _classCallCheck(this, Error);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      return /*#__PURE__*/_jsx("div", {
        className: "view ".concat(style.container),
        children: /*#__PURE__*/_jsx("img", {
          src: "/images/layout/error.png",
          alt: "\uC2DC\uC2A4\uD15C \uC810\uAC80\uC911 \uC785\uB2C8\uB2E4. \uC11C\uBE44\uC2A4 \uC774\uC6A9\uC5D0 \uBD88\uD3B8\uC744 \uB4DC\uB824\uC11C \uB300\uB2E8\uD788 \uC8C4\uC1A1\uD569\uB2C8\uB2E4."
        })
      });
    });

    return _this;
  }

  return Error;
}(Component);

export { Error as default };